(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        window.pauseAllMedia();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template').content.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      this.elements.input.value = event.currentTarget.dataset.value;
      this.querySelector('form').submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.preventReveal) {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      } else {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.reveal.bind(this));
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-addon"]) return;
  try {
    
class ProductModal extends ModalDialog {
constructor() {
super();
}

hide() {
super.hide();
window.pauseAllMedia();
}

show(opener) {
super.show(opener);
this.showActiveMedia();
}

showActiveMedia() {
this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
element.classList.remove('active');
}
)
const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
activeMedia.classList.add('active');
activeMedia.scrollIntoView();

const container = this.querySelector('[role="document"]');
container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template').content.querySelector('.js-youtube'))
activeMedia.loadContent();
}
}

customElements.define('product-modal', ProductModal);

class ImpactLink extends HTMLElement {
constructor() {
super();

const button = this;
button.addEventListener('click', () => {
document.querySelector('.product-single__impact-tooltip-bg').classList.add('open');
document.querySelector('.product-single__impact-tooltip').classList.add('open');
});

document.querySelector('.js-close-impact-tooltip svg').addEventListener('click', () => {
this.closeImpact();
});

document.querySelector('.product-single__impact-tooltip-bg').addEventListener('click', () => {
this.closeImpact();
});
}

closeImpact() {
document.querySelector('.product-single__impact-tooltip-bg').classList.remove('open');
document.querySelector('.product-single__impact-tooltip').classList.remove('open');
}
}

customElements.define('impact-link', ImpactLink);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-alternate"]) return;
  try {
    
class ProductModal extends ModalDialog {
constructor() {
super();
}

hide() {
super.hide();
window.pauseAllMedia();
}

show(opener) {
super.show(opener);
this.showActiveMedia();
}

showActiveMedia() {
this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
element.classList.remove('active');
}
)
const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
activeMedia.classList.add('active');
activeMedia.scrollIntoView();

const container = this.querySelector('[role="document"]');
container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template').content.querySelector('.js-youtube'))
activeMedia.loadContent();
}
}

customElements.define('product-modal', ProductModal);

class ImpactLink extends HTMLElement {
constructor() {
super();

const button = this;
button.addEventListener('click', () => {
document.querySelector('.product-single__impact-tooltip-bg').classList.add('open');
document.querySelector('.product-single__impact-tooltip').classList.add('open');
});

document.querySelector('.js-close-impact-tooltip svg').addEventListener('click', () => {
this.closeImpact();
});

document.querySelector('.product-single__impact-tooltip-bg').addEventListener('click', () => {
this.closeImpact();
});
}

closeImpact() {
document.querySelector('.product-single__impact-tooltip-bg').classList.remove('open');
document.querySelector('.product-single__impact-tooltip').classList.remove('open');
}
}

customElements.define('impact-link', ImpactLink);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
constructor() {
super();
}

hide() {
super.hide();
window.pauseAllMedia();
}

show(opener) {
super.show(opener);
this.showActiveMedia();
}

showActiveMedia() {
this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
element.classList.remove('active');
}
)
const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
activeMedia.classList.add('active');
activeMedia.scrollIntoView();

const container = this.querySelector('[role="document"]');
container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template').content.querySelector('.js-youtube'))
activeMedia.loadContent();
}
}

customElements.define('product-modal', ProductModal);

class ImpactLink extends HTMLElement {
constructor() {
super();

const button = this;
button.addEventListener('click', () => {
document.querySelector('.product-single__impact-tooltip-bg').classList.add('open');
document.querySelector('.product-single__impact-tooltip').classList.add('open');
});

document.querySelector('.js-close-impact-tooltip svg').addEventListener('click', () => {
this.closeImpact();
});

document.querySelector('.product-single__impact-tooltip-bg').addEventListener('click', () => {
this.closeImpact();
});
}

closeImpact() {
document.querySelector('.product-single__impact-tooltip-bg').classList.remove('open');
document.querySelector('.product-single__impact-tooltip').classList.remove('open');
}
}

customElements.define('impact-link', ImpactLink);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-inspiration"] && !Shopify.designMode) return;
  try {
    
  class SectionTab extends HTMLElement {
    constructor() {
      super();

      const container = this,
            tabHeader = container.querySelectorAll('.tab-header'),
            tabContent = container.querySelectorAll('.tab-content');

      for (let i = 0; i < tabHeader.length; i++) {
        tabHeader[i].onclick = function() {
          var ch = 0;
          var cc = 0;
          while (ch < tabHeader.length) {
            tabHeader[ch++].classList.remove("active");
          }
          while (cc < tabContent.length) {
            tabContent[cc++].classList.remove("active");
          }
          tabHeader[i].classList.add("active");
          tabContent[i].classList.add("active");
        };
      }
    }
  }

  customElements.define('section-tab', SectionTab);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            const swiperHtml = this.querySelector('.swiper');

            const recommendationsSwiper = new Swiper(swiperHtml, {
              slidesPerView: 4.5,
              spaceBetween: 31,
              navigation: {
                nextEl: '#Next-recommendations',
              },
              breakpoints: {
                320: {
                  slidesPerView: 1.6,
                  spaceBetween: 11,
                  loop: true,
                },
                576: {
                  slidesPerView: 2.6,
                  spaceBetween: 20,
                },
                750: {
                  slidesPerView: 4.5,
                  spaceBetween: 31,
                },
              },
            });

            if (isMobile) {
              swiperHtml.classList.add('swiper-mobile');
              recommendationsSwiper.destroy();
            }

          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-shoutouts"]) return;
  try {
    
  class ProductShoutouts extends HTMLElement {
    constructor() {
      super();
      const isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
      const dataId = this.getAttribute('data-section-id'),
            swiperHtml = this.querySelector('.swiper'),
            swiperLength = this.querySelectorAll('.swiper-slide').length;

      var isLoopPc = false,
          isLoopTab = false,
          isLoopMb = false;

      if(swiperLength > 4) {
        isLoopPc = true;
      }
      if(swiperLength > 2) {
        isLoopTab = true;
      }
      if(swiperLength > 1) {
        isLoopMb = true;
      }

      const shoutoutsSwiper = new Swiper(swiperHtml, {
        loop: false,
        slidesPerView: 4,
        spaceBetween: 31,
        navigation: {
          nextEl: '#Next-'+dataId,
        },
        breakpoints: {
          320: {
            slidesPerView: 1.6,
            spaceBetween: 11,
            loop: isLoopMb,
          },
          576: {
            slidesPerView: 2.6,
            spaceBetween: 20,
            loop: isLoopTab,
          },
          750: {
            slidesPerView: 4,
            spaceBetween: 31,
            loop: isLoopPc,
          },
        },
      });
      if (isMobile) {
        swiperHtml.classList.add('swiper-mobile');
        shoutoutsSwiper.destroy();
      }
    }
  }

  customElements.define('product-shoutouts', ProductShoutouts);

  } catch(e) { console.error(e); }
})();
})();
